module.exports = __webpack_public_path__ + "static/media/portfolio (21).a74b44aa.jpg";